import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { isSessionExpired } from "../../strict/app/AppOverlayController";
import { LoadingIcon } from "../ui/LoadingIcon";

type AuthenticationGuardProps = {
  component: React.ComponentType<object>;
};

export const AuthenticationGuard = ({ component: Component }: AuthenticationGuardProps) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    // Mid-session expiry defers to the overlay; a fresh unauthenticated visit still redirects.
    if (!isLoading && !isAuthenticated && !isSessionExpired()) {
      loginWithRedirect({ appState: { returnTo: window.location.pathname + window.location.hash } });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading || !isAuthenticated) {
    return <LoadingIcon boxWidth="100vw" boxHeight="100vh" />;
  }

  return <Component />;
};
